import { Box } from '@mui/material';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import React from 'react';
import { IPagination } from '../interfaces/shared/IPagination';
import CustomDataGridSkeleton from './CustomDataGridSkeleton';

interface CustomDataGridProps<T> {
  rows: T[];
  columns: GridColDef[];
  rowCount?: number;
  pagination?: IPagination;
  setPagination?: React.Dispatch<React.SetStateAction<IPagination>>;
  loading?: boolean; // Optional loading state
  hideFooterPagination?: boolean;
  hasNextPage?: boolean;
}
const CustomDataGrid = <T,>({
  rows = [],
  columns,
  rowCount,
  pagination,
  setPagination,
  hideFooterPagination = false,
  hasNextPage = false,
  loading = false,
}: CustomDataGridProps<T>) => {
  return (
    <Box sx={{ flex: 1, width: '100%' }}>
      {loading ? (
        <CustomDataGridSkeleton columns={columns} />
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          hideFooterPagination={hideFooterPagination}
          rowSelection={false}
          disableRowSelectionOnClick
          loading={loading}
          pageSizeOptions={[30, 50, 100]}
          rowCount={rowCount}
          paginationModel={
            pagination
              ? {
                  page: pagination?.page,
                  pageSize: pagination?.perPage,
                }
              : undefined
          }
          paginationMeta={{
            hasNextPage,
          }}
          paginationMode="server"
          onPaginationModelChange={(value: GridPaginationModel) => {
            setPagination &&
              setPagination((prev) => ({
                ...prev,
                perPage: value.pageSize,
                page: value.page,
              }));
          }}
          sx={{
            // to hide header when we want to
            '& .hideColumn': {
              display: 'none',
            },
          }}
        />
      )}
    </Box>
  );
};

export default CustomDataGrid;
